import { useNavigate } from "react-router-dom";
import "./Home.css";
// import VerticalContact from "../../individual/VerticalContact/VerticalContact";
import congressLogo from "../../../assets/Logo 4ºC.png";

const Home = () => {
  const navigate = useNavigate();
  return (
    <div className="home__container" id="home">
      <img
        src={congressLogo}
        alt="congress-logo"
        className="home__congress-logo"
      />
      <p className="home__welcome-text">
        El Col·legi d&#39;Economistes de Catalunya organitza el 4rt Congrés
        d&#39;Economia i Empresa de Catalunya 2025,&nbsp;
        <span style={{ fontStyle: "italic", fontWeight: "bolder" }}>
          Cap a una economia més digital i sostenible.
        </span>
        &nbsp;Participa en aquest fòrum transversal que agrupa reflexions al
        voltant de grans temes com la globalització, la macroeconomia,
        l’estructura empresarial, el capital humà, el sistema públic, la
        innovació, les finances, les infraestructures, la transició energètica,
        la sostenibilitat mediambiental i el futur de la professió d’economista.
        La sessió final i lectura de conclusions tindrà lloc el 20 de juny a les
        8.45h a l&#39;Auditori L’Illa de Barcelona, amb la participació del
        president de la Generalitat, Salvador Illa, el president del Parlament,
        Josep Rull, el ministre d’Indústria i Turisme, Jordi Hereu, i l’alcalde
        de Barcelona, Jaume Collboni. &nbsp;
        <div
          style={{
            display: "inline-block",
            padding: "0.4rem 0.8rem",
            backgroundColor: "#003a83",
            color: "#fff",
            borderRadius: "6px",
            textDecoration: "none",
            fontWeight: "bold",
            fontSize: "1rem",
            transition: "background-color 0.3s ease",
          }}
          className="inscription-button"
          onMouseEnter={(e) => (e.target.style.backgroundColor = "#002b63")}
          onMouseLeave={(e) => (e.target.style.backgroundColor = "#003a83")}
          onClick={() => {
            navigate("/sessio-final");
          }}
        >
          Inscripció
        </div>
      </p>
    </div>
  );
};

export default Home;
